var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('loader',{attrs:{"object":"#4b33ff","color1":"#ffffff","color2":"#17fd3d","size":"5","speed":"3","bg":"#343a40","objectbg":"#999793","opacity":"80","disableScrolling":"false","name":"box"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }